import { getAppConfiguration } from "appConfig";
import axios from "axios";
import ct from "countries-and-timezones";
import { axiosEjFetch } from "./axiosEjHelpers";
import { axiosFetch } from "./axiosHelpers";

export async function postPrice<T>(body: T) {
  return axiosEjFetch.post("/api/pricing/search", body);
}

export async function getPriceList(providerId: string) {
  return axiosEjFetch.get(`/api/devicePrice/getPrices/${providerId}`);
}

export async function getCityAutocomplete(term: string, useLimit?: boolean) {
  const appConfiguration = await getAppConfiguration();
  const limit = useLimit ? "&limit=10" : "";
  const mapboxUrl = `${appConfiguration.mapBoxUrl?.replace(
    "%TOKEN%",
    appConfiguration.mapBoxToken
  )}${limit}`;

  const response = await axios.get(mapboxUrl?.replace("%VALUE%", term) || "");
  return response.data;
}

export async function getClientLatLong() {
  const appConfiguration = await getAppConfiguration();
  if (!appConfiguration.ipApiUrl) {
    console.warn("IP_API_URL is not configured, skipping geolocation");
    return null;
  }
  return axios.get(appConfiguration.ipApiUrl);
}

export async function getDevicePriceDetails(deviceId: string) {
  return axiosEjFetch.get(`/api/devicePrice/${deviceId}`);
}

export async function fetchCountries() {
  return axiosEjFetch.get("/api/country");
}

export async function fetchCountryStates(countryCode: string) {
  return axiosEjFetch.get(`/api/country/${countryCode}/states`);
}

export function getTimezoneFromCountryCode(
  countryCode: string,
  longitude?: number
): string | null {
  try {
    const timezones = ct.getTimezonesForCountry(countryCode);
    if (!timezones || timezones.length === 0) return null;

    if (timezones.length === 1) return timezones[0].name;

    if (longitude == null) return timezones[0].name;

    // Multiple timezones → find the closest one based on longitude
    // 1 hour of UTC offset ≈ 15° of longitude
    const estimatedOffset = Math.round(longitude / 15);

    const closest = timezones.reduce((prev, curr) => {
      const prevDiff = Math.abs(prev.utcOffset / 60 - estimatedOffset);
      const currDiff = Math.abs(curr.utcOffset / 60 - estimatedOffset);
      return currDiff < prevDiff ? curr : prev;
    });

    return closest.name;
  } catch {
    return null;
  }
}
